import {
  FETCH_CTC_SELLING_ORDER_BY_USERID,
  FETCH_CTC_SOLD_ORDER_BY_USERID,
  FETCH_CTC_BUYER_ORDER,
  FETCH_CTC_SELLER_ORDER,
  SAVE_CTC_BUY_ORDER_DATA,
} from '../mutation-types'

const initialState = {
  sellingOrderListData: [],
  soldOrderListData: [],
  buyerOrder: null,
  sellerOrder: null,
  ctcBuyOrderData: {
    ticketId: 0,
    amount: 1,
    attn: {
      id: '',
    },
    contactIdNo: '',
  },
}

const mutations = {
  [FETCH_CTC_SELLING_ORDER_BY_USERID](state, data) {
    state.sellingOrderListData = data
  },
  [FETCH_CTC_SOLD_ORDER_BY_USERID](state, data) {
    state.soldOrderListData = data
  },
  [FETCH_CTC_BUYER_ORDER](state, data) {
    state.buyerOrder = data
  },
  [FETCH_CTC_SELLER_ORDER](state, data) {
    state.sellerOrder = data
  },
  [SAVE_CTC_BUY_ORDER_DATA](state, data) {
    state.ctcBuyOrderData = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/ctcOrder.js